<template>
  <div>
    <el-submenu :index="item.id + ''">
      <template slot="title">
        <a :index="item.id + ''" @click="handleTitleClick(item)">
          {{ item.name == "产品列表" ? "资产管理" : item.name }}
        </a>
      </template>

      <template v-for="child in (item.children || [])">
        <header-sidebar-item
          v-if="child.children && child.children.length > 0"
          :item="child"
          :key="child.id"
          @change="change"
        />

        <el-menu-item
          v-else
          :key="child.id"
          :index="child.id + ''"
          @click="click(child)"
        >
          <i class="el-icon-minus"></i>
          {{ child.name }}
        </el-menu-item>
      </template>
    </el-submenu>
  </div>
</template>

<script>
export default {
  name: "HeaderSidebarItem",
  data() {
    return {
      token: Number,
      showItemId: null,
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    id: {
      type: Number,
      required: 0,
    },
    name: {
      type: String,
      required: "",
    },
  },
  mounted() {
    // 假设从某个全局状态管理器或本地存储获取token
    this.token = localStorage.getItem("token");
  },
  methods: {
    change(item) {
      this.click(item.item);
    },
    click(item) {
      console.log(item);
      this.$emit("change", {
        item,
        id: this.id,
        name: this.name,
      });
    },
    // 点击父菜单标题：保留 走进财达 (id=110) 跳转 WineCulture 的原逻辑
    handleTitleClick(item) {
      if (item && item.id == 110) {
        this.$router.push("/WineCulture?type=" + item.id);
      } else {
        this.click(item);
      }
    },
    back(i, idx) {
      this.n = idx;
      this.$router.push(i);
      this.showItemId = false;
    },
    clicks() {
      this.back("/WineCulture?type=" + this.id);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/HeaderSidebarItem.vue